















































































































































































































































































































































import {Component, Mixins, Watch} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import NavbarDropdown from '@/components/navbar/NavbarDropdown.vue'
import NavbarDropdownItem from '@/components/navbar/NavbarDropdownItem.vue'
import SessionButton from '@/components/SessionButton.vue'
import NavbarWalletSession from '@/components/navbar/NavbarWalletSession.vue'
import NetworkModeBar from '@/components/navbar/NetworkModeBar.vue'
import {State} from '@/enums/State'
import {NetworkModeHelper} from '@/helpers/NetworkModeHelper'

@Component({
  components: {
    NavbarWalletSession,
    NavbarDropdownItem,
    NavbarDropdown,
    NetworkModeBar,
    SessionButton,
  },
})
export default class Navbar extends Mixins(MixinScreenSize) {
  State = State
  state = State.NORMAL
  scrollPosition = 0
  $refs!: {
    sidebarRef: HTMLElement
  }

  get isOrbitEnabled(): boolean {
    return this.$auth?.global?.isOrbitFeatureActive !== false
  }

  /** Pages with nothing to show on the network in use are left out entirely. */
  isAvailable(routeName: string): boolean {
    return NetworkModeHelper.isRouteAvailable(routeName)
  }

  preventTouchMove = (e: TouchEvent) => {
    const sidebar = this.$refs.sidebarRef
    if (sidebar && sidebar.contains(e.target as Node)) {
      return
    }
    e.preventDefault()
  }

  @Watch('state')
  onStateChange(newState: State) {
    if (newState === State.SIDEBAR_OPEN) {
      this.scrollPosition =
        window.pageYOffset || document.documentElement.scrollTop

      document.documentElement.style.overflow = 'hidden'
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      document.body.style.top = `-${this.scrollPosition}px`
      document.body.style.left = '0'
      document.body.style.right = '0'
      document.body.style.width = '100%'

      document.addEventListener('touchmove', this.preventTouchMove, {
        passive: false,
      })
      return
    }

    document.documentElement.style.overflow = ''
    document.body.style.overflow = ''
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.left = ''
    document.body.style.right = ''
    document.body.style.width = ''

    document.removeEventListener('touchmove', this.preventTouchMove)

    window.scrollTo(0, this.scrollPosition)
  }

  beforeDestroy() {
    document.removeEventListener('touchmove', this.preventTouchMove)
    document.documentElement.style.overflow = ''
    document.body.style.overflow = ''
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.left = ''
    document.body.style.right = ''
    document.body.style.width = ''
  }

  isStateIn(...states: number[]) {
    return states.includes(this.state)
  }

  goToState(state: State) {
    this.state = this.state === state ? State.NORMAL : state
  }

  resetState() {
    this.state = State.NORMAL
  }

  classLink(...names: string[]) {
    return {
      'navbar__link--active': names.includes(this.$route.name as string),
    }
  }
}
